// extracted by mini-css-extract-plugin
export default {"wrapper":"PageName_wrapper__J1Ou9","backButton":"PageName_backButton__5o-Tl"};